import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { WASTE_WOOD_GROUP_TYPE, WASTE_WOOD_TYPE, WOOD_GRADE_CHOICES } from "../../constance/dataTypes";
import * as _ from "lodash";
import { Form, Input, InputNumber,  Select } from "antd";
import { defaultPostBakingWasteWoodInputDetail } from "../../constance/dataTypes";


export default function InputWasteWoodForm(props) {
  const {
    style,
    form,
  } = props;

  const { t } = useTranslation();

  const grade = Form.useWatch('grade', form);
  const wood_size = Form.useWatch('wood_size', form);
  const amount = Form.useWatch('amount', form);

  const [wasteWoodTypeOptions, setWasteWoodTypeOptions] = React.useState([]);
  const wasteWoodGroupOptions = Object.entries(WASTE_WOOD_GROUP_TYPE).map(([_, value]) => ({
    key: value, value, label: t(`post_baking_waste_wood_input.waste_wood_groups.${value}`)
  }))

  React.useEffect(() => {
    const selectedGroup = form.getFieldValue('waste_wood_group');
    setWasteWoodTypeOptions(
      Object.entries(WASTE_WOOD_TYPE[selectedGroup] || {}).map(([_, value]) => ({
        key: value, value, label: t(`post_baking_waste_wood_input.waste_wood_types.${value}`)
      }))
    )
  }, [form.getFieldValue('waste_wood_group')])

  return (
    <Form
      style={{ width: 'fit-content', margin: 'auto', textAlign: 'left', ...style }}
      form={form}
      initialValues={defaultPostBakingWasteWoodInputDetail}>
      <Form.Item name={'transaction'} hidden />
      <Form.Item
        label={t('wood_imports.grade')}
        name={'grade'}
        rules={[{ required: true, message: t('error_messages.validation.required') }]}>
        <Select options={WOOD_GRADE_CHOICES} />
      </Form.Item>
      <Form.Item
        label={t('wood_size')}
        name='wood_code_dimension'
        rules={[
          { required: true, message: t('error_messages.validation.required') },
          { len: 10, message: t('error_messages.validation.length') }
        ]}>
        <Input />
      </Form.Item>
      <Form.Item
        label={t('barcodes.amount')}
        name='amount'
        rules={[{ required: true, message: t('error_messages.validation.required') },
        {
          validator: (_, value) => {
            if (value <= 0) {
              return Promise.reject(`${t('error_messages.validation.more_than')} 0`);
            }
            return Promise.resolve();
          },
        },
        ]}>
        <InputNumber style={{width: '100%'}}/>
      </Form.Item>
    </Form>
  )
}

InputWasteWoodForm.propTypes = {
  style: PropTypes.object,
  form: PropTypes.object,
}

InputWasteWoodForm.defaultProps = {
  style: {},
}